var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-tab-panel',_vm._b({staticClass:"q-pa-none"},'q-tab-panel',Object.assign({}, {name: _vm.name}, _vm.$attrs),false),[(_vm.noScroll)?_vm._t("default"):_c('ModalScrollArea',[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }